<template lang="pug">
  base-container
    avue-crud(
      ref="crud",
      :data="data",
      :table-loading="loading",
      :option="option",
      :page.sync="page",
      @search-change="searchChange",
      @search-reset="searchReset",
      @current-change="currentChange",
      @size-change="sizeChange",
      @refresh-change="refreshChange",
      @on-load="onLoad"
    )
      template(slot="module" slot-scope="scope")
        el-tag {{scope.row.module}}
</template>
<script>
/**
 * 系统管理-操作日志-列表
 */
import { getLogList } from "@/api/sysmanager";
export default {
  name: "SysLog",
  components: {},
  data() {
    return {
      form: {},
      data: [],
      query: {},
      loading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        indexLabel: "编号",
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        addBtn: false,
        editBtnText: "更新",
        searchShow: true,
        columnBtn: false,
        searchBtnText: "查询",
        emptyBtnText: "重置",
        stripe: true,
        searchSpan: 9,
        searchMenuSpan: 7,
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        menuWidth: 200,
        menu: false,
        column: [
          {
            label: "操作人",
            prop: "operator",
            search: true,
          },
          {
            label: "操作模块",
            prop: "module",
            search:true,
            slot:true,
            overHidden:true
          },{
            label: "操作内容",
            prop: "action",
            overHidden:true
          },
          {
            label: "创建时间",
            prop: "createDate",
            type: "daterange",
            valueFormat:"yyyy-MM-dd hh:mm:ss",
            search: true,
            searchRange: true,
          },
        ],
      },
    };
  },
  methods: {

    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      const { createDate } = params;
      let values = { ...params };
      if (createDate) {
        values = {
          ...params,
          createDateStart: createDate[0],
          createDateEnd: createDate[1],
        };
        values.createDate = null;
        this.query.createDate = null;
      }
      this.loading = true;
      getLogList(page.currentPage, page.pageSize, { ...values, ...this.query })
        .then((res) => {
          const data = res.data;
          this.page.total = res.total;
          this.data = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style>
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>
